import axios from 'axios'

const baseUrl = process.env.REACT_APP_API_HOST;

const db = {
    /**
     * 
     * @param {*} str : table name
     */
    getAllDb(table) {
        return axios({
            url: `${baseUrl}/api/${table}`,
            method: 'GET'
        }).then(response => {
            return response.data
        })
    },
    postAllDb(table, data) {
        console.log(data)
        return axios({
            url: `${baseUrl}/api/${table}`,
            method: 'POST',
            data: data
        }).then(response => {
            return response.data
        })
    },
    deleteAllDbById(table, id) {
        return axios({
            url: `${baseUrl}/api/${table}`,
            method: 'DELETE',
            data: { id: id }
        }).then(response => {
            return response.data
        })
    },
    putAllDbById(table, data, id) {
        return axios({
            url: `${baseUrl}/api/${table}`,
            method: 'PUT',
            data: data
        }).then(response => {
            return response.data
        })
    },
    //user API
    login(id, pw) {
        return axios({
            url: `${baseUrl}/api/user/${id}/${pw}`,
            method: 'get',
        }).then(response => {
            return response.data
        })
    },
    logout() {
        return axios({
            url: `${baseUrl}/api/user/logout`,
            method: 'get',
        }).then(response => {
            return response.data
        })
    },
    //carousel
    getImagesByCategory(category) {
        return axios({
            url: `${baseUrl}/api/image/${category}`,
            method: 'get',
        }).then(response => {
            return response.data
        })
    },
    postImage(data) {
        return axios({
            url: `${baseUrl}/api/image`,
            method: 'post',
            data: data
        }).then(response => {
            return response.data
        })
    },
    putImage(data) {
        return axios({
            url: `${baseUrl}/api/image`,
            method: 'put',
            data: data
        }).then(response => {
            return response.data
        })
    },
}
export default db;